/* Eloura. Reduced motion: hold looping videos on their poster frame instead of playing them.
   The reveal-on-scroll that used to live here was removed 2026-10-06 at the user's request;
   [data-reveal] attributes left in sections are inert. */
(function () {
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    document.querySelectorAll("video[autoplay]").forEach(function (v) { v.removeAttribute("autoplay"); v.pause(); });
  }
})();
